import { Modal, Segmented, Input, Button, Tabs, Avatar as AntdAvatar } from 'antd'
import { styled, keyframes } from 'styled-components'
import { COLORS, SHADOWS } from 'tokens'

const flash = (bgColor: any) => keyframes`
  0% {
    background-color: ${bgColor};
    border: 1px solid transparent;
    color: #ffffff;
  }
  50% {
    background-color: var(--color-bg);
    border: 1px solid var(--color-disabled);
    color: #000000;
  }
  100% {
    background-color: ${bgColor};
    border: 1px solid transparent;
    color: #ffffff;
  }
`

// currentPatientScreen
export const PatientDetailWrapper = styled.div`
  align-items: flex-start;
  background: var(--color-bg);
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  gap: 24px;
  max-height: 851px;
`

//AssessmentPanel
export const MiddleSection = styled.div`
  min-width: 614px;
  min-height: 851px;
  width: 40%;
  // width: 614px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 20px;
  padding-bottom: 20px;
`

export const TabSelector = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  // border: 1px solid var(--color-border-primary);
  margin-bottom: 16px;
  justify-content: flex-end;
  // box-shadow: var(--shadow-box);
`

export const TabButton = styled.div`
  width: 68px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 28px;
  padding-right: 28px;
  margin-right: 26px;
`

export const MetricsSection = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: transparent;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 8px;
  margin-left: 20px;
  margin-right: 20px;
  gap: 8px;
`

export const MetricsRow = styled.div`
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  margin-left: 16px;
  margin-right: 16px;
`

export const MetricsColumn = styled.div`
  width: 58px;
  display: flex;
  flex-direction: column;
  margin-right: 8px;
  gap: 8px;
`

export const PainScaleBox = styled.div<{
  $bg?: string
  $border?: string
  $textColor?: string
  $animation?: boolean
  $disabled?: boolean
}>`
  width: 38px;
  height: 124px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.$bg || 'var(--color-bg)'};
  border-radius: 4px;
  border: ${(props) =>
    props.$disabled || props.$border ? `1px solid var(--color-disabled)` : `1px solid transparent`};
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 14px;
  padding-right: 14px;
  margin-right: 2px;
  color: ${(props) => (props.$disabled || props.$textColor ? 'var(--color-disabled)' : 'var(--color-text-secondary)')};
  animation: ${(props) => (props.$animation ? flash(props.$bg) : 'none')} 1.5s infinite;
`

export const PainScaleText = styled.span<{ $color?: string; $animation?: boolean }>`
  font-size: 16px;
  font-weight: bold;
  color: inherit;
`

export const PainScaleLabels = styled.div`
  display: flex;
  align-items: flex-start;
  margin-left: 82px;
  gap: 56px;
`

export const SymptomsSection = styled.div`
  height: 72px;
  // min-width: 574px;
  width: calc(100% - 40px);
  display: flex;
  padding: 16px;
  margin-bottom: 8px;
  margin-left: 20px;
  margin-right: 20px;
  gap: 16px;
  border: 1px solid ${COLORS.borderPrimary} !important;
  border-radius: 6px;
`

export const SymptomsCard = styled.div<{ $width?: string; $paddingLeft?: string; $paddingRight?: string }>`
  // width: ${(props) => props.$width || '124px'};
  width: 124px;
  height: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 8px;
  border: 1px solid var(--color-border-primary);
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${(props) => props.$paddingLeft || '16px'};
  padding-right: ${(props) => props.$paddingRight || '16px'};
`

export const SummaryNote = styled.div`
  width: calc(100% - 40px);
  min-height: 128px;
  max-height: 128px;
  overflow-y: auto;
  margin: 0 20px 169px;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderPrimary};
  background: var(--color-bg);
  color: var(--color-text-primary);
  font-size: 16px;
  padding: 16px;
  resize: none;
  line-height: 1.4;

  &::placeholder {
    color: var(--color-disabled);
  }
`

export const DateInputRow = styled.div`
  height: 80px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
  margin-left: 20px;
  margin-right: 20px;
`

export const DateInfo = styled.div`
  width: 250px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

export const AppointmentRow = styled.div`
  height: 80px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);

  margin-left: 20px;
  margin-right: 20px;
`

export const AppointmentInfo = styled.div`
  width: 250px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 12px;
  margin-bottom: 16px;
  margin-left: 16px;
  gap: 8px;
`

export const ScanTag = styled.div`
  height: 20px;
  width: 93px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border: 1px solid var(--color-border-primary);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-top: none;
  border-right: none;
  padding: 3px 15px 2px 14px;
  margin-left: 22px;
`

export const AppointmentTimeContainer = styled.div`
  width: 115px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`

export const StyledSegmented = styled(Segmented)`
  background: transparent !important;
  box-shadow: ${SHADOWS.boxShadow} !important;
  font-weight: 400;
  min-width: 136px;
  margin-right: 20px;
  border: 1px solid ${COLORS.borderPrimary} !important;
  border-radius: 6px !important;
  padding: 0 !important;
  background: ${COLORS.background} !important;

  && .ant-segmented-thumb {
    background: ${COLORS.primary} !important;
    border-radius: 6px !important;
    transition: transform 0.1s ease-out !important; /* Faster - 100ms */
    box-shadow: none !important;
  }

  .ant-segmented-item {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    border-radius: 6px !important;
    min-width: 68px !important;
    color: ${COLORS.textPrimary} !important;
    font-weight: 400 !important;
    transition: none !important;
  }

  .ant-segmented-item-selected {
    box-shadow: none !important;
    background: ${COLORS.primary} !important;
    color: ${COLORS.textSecondary} !important;
    min-width: 68px !important;
    font-weight: 700 !important;
    border-radius: 4px !important;
    transition: none !important;
  }

  /* Force immediate color change with higher specificity */
  && .ant-segmented-item-selected {
    color: ${COLORS.textSecondary} !important;
    font-weight: 700 !important;
  }

  /* Style first item when selected (S) */
  .ant-segmented-item:first-child.ant-segmented-item-selected {
    border-right: 1px solid ${COLORS.borderPrimary} !important;
  }

  /* Style last item when selected (W) */
  .ant-segmented-item:last-child.ant-segmented-item-selected {
    border-left: 1px solid ${COLORS.borderPrimary} !important;
  }
`

export const MetricButtons = styled.div`
  width: 58px;
  min-width: 58px;
  max-height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 3px;
  padding-left: 13px;
  padding-right: 13px;
  gap: 2px;
  text-align: left;
`

export const MetricValues = styled.span`
  color: var(--color-text-primary);
  font-size: 30px;
  margin-bottom: 11px;
`
export const Text = styled.span<{
  $bold?: boolean
  $size?: number
  $color?: string
  $marginRight?: number
  $marginBottom?: number
  $marginTop?: number
}>`
  color: ${(props) => props.$color || 'var(--color-text-primary)'};
  font-size: ${(props) => props.$size || 16}px;
  font-weight: ${(props) => (props.$bold ? '700' : 'normal')};
  margin-right: ${(props) => (props.$marginRight ? `${props.$marginRight}px` : '0')};
  margin-bottom: ${(props) => (props.$marginBottom ? `${props.$marginBottom}px` : '0')};
  margin-top: ${(props) => (props.$marginTop ? `${props.$marginTop}px` : '0')};
`

//PatientProfilePanel

const flashBirthDayLabel = (color: string) => keyframes`
  0% { background-color: ${color}; color: #fffeff; }
  50% { background-color: #10123d; color: #fffeff; }
  100% { background-color: ${color}; color: #fffeff; }
`

export const LeftSection = styled.div`
  // width: 30%;
  min-width: 280px;
  width: 30%;
  // width: 280px;
  min-height: 851px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
`

export const CardImage = styled.div<{ $src: string }>`
  align-self: stretch;
  min-width: 240px;
  min-height: 240px;
  height: 240px;
  max-width: 240px;
  display: flex;
  flex-direction: column;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 12px;
  margin-right: 20px;
  background-image: url(${(props) => props.$src});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
`

export const CardImageContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 154px;
`

export const KiroLogo = styled.img`
  width: 30px;
  height: 30px;
  object-fit: fill;
`

export const AgeBox = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  margin-left: auto;
`

export const SourceIdentifier = styled.button<{ $noBorder?: boolean; $bg?: string }>`
  width: 216px;
  height: 30px;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.$bg || 'var(--color-bg)'};
  border-radius: 6px;
  border: ${(props) => (props.$noBorder ? 'none' : `1px solid var(--color-border-primary)`)};
  text-align: left;
  box-shadow: ${(props) => (props.$noBorder ? 'none' : 'var(--shadow-box)')};
`

export const NameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-right: 132px;
  width: 100%;
  text-transform: capitalize;
  // white-space: pre-line;
`
export const LastNameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-top: -6px;
  margin-bottom: 12px;
  width: 100%;
  text-transform: capitalize;
  // white-space: pre-line;
`
export const MetricRow = styled.div`
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  margin-right: 20px;
  gap: 8px;
`

export const MetricButton = styled.div`
  width: 58px;
  min-width: 58px;
  max-height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 3px;
  padding-left: 13px;
  padding-right: 13px;
  gap: 2px;
  text-align: left;
`

export const MetricValue = styled.span`
  color: var(--color-text-primary);
  font-size: 30px;
  margin-bottom: 11px;
`

export const ScanBox = styled.div`
  max-height: 58px;
  width: 108px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffce00;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 11px;
  padding-right: 11px;
`

export const DateBox = styled(Button)`
  height: 29px;
  min-width: 240px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: transparentq;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 2.5px;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 118px;
  margin-right: 20px;
`

export const AppointmentCard = styled.div<{ $marginBottom?: string }>`
  align-self: stretch;
  min-width: 240px;
  height: 48px;
  display: flex;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  margin-bottom: ${(props) => props.$marginBottom || '8px'};
  margin-right: 20px;
  gap: 9px;
  box-shadow: var(--shadow-box);
`

export const PersonImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: fill;
`

export const DoneButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  // margin-top: auto;
`

export const NavigationButtonsContainer = styled.div`
  align-self: stretch;
  display: flex;
  gap: 8px;
  margin-top: auto;
  // margin-bottom: 8px;
  margin-right: 20px;
`

export const NavigationButton = styled.button<{ $disabled?: boolean }>`
  flex: 1;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: ${(props) => (props.$disabled ? 'var(--color-disabled-bg)' : 'var(--color-bg)')};
  border-radius: 6px;
  border: 1px solid ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'var(--color-border-primary)')};
  color: ${(props) => (props.$disabled ? 'var(--color-disabled)' : 'var(--color-text-primary)')};
  font-size: 20px;
  font-weight: 700;
  box-shadow: var(--shadow-box);
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  transition: 0.2s;
  opacity: ${(props) => (props.$disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background: ${(props) => (props.$disabled ? 'var(--color-disabled-bg)' : 'var(--color-bg)')};
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const CheckInButton = styled(Button)`
  height: 52px;
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  margin-top: 8px;
`

export const AppointmentsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 168px;
  min-height: 168px;
  overflow: hidden;
  margin-right: 20px;
  padding-right: 20px;
  justify-content: flex-end;
  margin-top: auto;
`

//info

export const InfoCard = styled.div`
  height: 128px;
  max-height: 128px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
`

export const InfoCardTitle = styled.span`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 4px;
  margin-left: 17px;
`

export const InfoCardContent = styled.div`
  overflow-y: auto;
  width: 100%;
`

export const InfoCardText = styled.span<{ $bold?: boolean }>`
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: ${(props) => (props.$bold ? '700' : 'normal')};
  margin-bottom: 8px;
  margin-left: 16px;
`

export const SelectableOption = styled.div<{}>`
  width: 100%;
`

export const NotesInput = styled.div`
  width: 100%;
  min-height: 128px;
  max-height: 128px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderPrimary};
  background: var(--color-bg);
  color: var(--color-text-primary);
  font-size: 16px;
  padding: 16px;
  resize: none;
  line-height: 1.4;

  &::placeholder {
    color: var(--color-disabled);
  }
`

export const NotesPlaceholder = styled.span`
  color: var(--color-disabled);
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 98px;
`

// Notes

export const Column = styled.div`
  width: 100%;
  min-height: 851px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
`

export const Card = styled.div`
  width: 100%;
  height: 80px;
  background: var(--color-background);
  border: 1px solid var(--color-border-primary);
  border-radius: 6px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 9px;
  box-shadow: var(--shadow-box);
  // margin-top: 50px;
`

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
`

export const Title = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 700;
`

export const Subtitle = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 400;
  margin-top: 2px;
`

export const NavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`

export const NavButton = styled.button<{ $disabled?: boolean }>`
  width: 152px;
  @media (min-width: 1370px) {
    width: 48%;
  }
  height: 52px;
  background: var(--color-background);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  color: var(--color-text-primary);
  opacity: 0.5;
  font-size: 20px;
  font-weight: 700;

  cursor: pointer;
  box-shadow: var(--shadow-box);
  transition: 0.2s;

  &:hover {
    background: var(--color-background);
  }
`
// Scans
export const ScanReportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background);
  border-radius: 4px;
  padding-top: 23px;
`

export const LoadingContainer = styled.div`
  height: 576px !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const Container: any = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  padding-top: 20px;
  padding-bottom: 14px;
  position: relative;
`

export const LeftBar = styled.div`
  position: relative;
  border-bottom: 32px solid #007f7c;
  border-left: 25px solid transparent;
  background-color: transparent;
`

export const LeftBarText = styled.div`
  position: absolute;
  top: 7px;
  left: 0px;
  font-weight: 700;
  font-size: 12px;
  background-color: none;
`

export const LeftBarContainer = styled.div`
  display: flex;
  position: absolute;
  right: 0px;
  z-index: 1;
  margin-top: -2px;
`

export const RightBarContainer = styled.div`
  display: flex;
  position: absolute;
  left: 0px;
  z-index: 1;
  margin-top: -2px;
`

export const RightBar = styled.div`
  position: relative;
  border-bottom: 32px solid #007f7c;
  border-right: 25px solid transparent;
  background-color: transparent;
`

export const RightBarText = styled.div`
  position: absolute;
  top: 7px;
  right: 0px;
  font-weight: 700;
  font-size: 12px;
  background-color: none;
`

export const HexagonContainer = styled.div`
  position: absolute;
  //   height: 21px;
  //   width: 24px;
  margin: 0px -64.5px 2.5px -64.5px;
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const Hexagon = styled.div`
  width: 32px;
  height: 32px;
  position: absolute;
  right: -80px;
  /* Outer hexagon = border */
  background: var(--color-border-primary); /* border color */
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: flex;
  align-items: center;
  justify-content: center;

  /* Inner hexagon */
  &::after {
    content: '';
    position: absolute;
    width: 30px; /* <--- smaller inner hexagon */
    height: 30px; /* subtract border thickness */
    background: #ffffff; /* inner color */
    clip-path: inherit;
  }
`

export const HexagonLabel = styled.div`
  z-index: 2;
  text-transform: capitalize;
  font-size: 10px;
  font-weight: bold;
  color: var(--color-text-primary);
`

export const LeftCircle = styled.div`
  background: #32344b;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  // margin-right: 25px;
  margin-top: 10px;
`

export const RightCircle = styled.div`
  background: #32344b;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  // margin-left: 20px;
  margin-top: 10px;
`
export const Score = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 33px;
  min-width: 73px;
  font-weight: 700;
  font-size: 24px;
  border-radius: 4px;
  padding-left: 26px;
`

export const DoctorProfile = styled(AntdAvatar)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
  min-height: 50px;
  overflow: hidden;
  border: 1px solid var(--color-border-primary);
`

// traffic

export const TrafficWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 771px;
`

export const Section = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
  flex-shrink: 0;
`

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-border-primary);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: var(--color-text-secondary);
  }
`
// patientReportParent

export const RightSection = styled.div`
  min-width: 360px;
  width: 30%;
  min-height: 851px;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
`

export const TrafficButton = styled.div<{ $active?: boolean }>`
  width: 81px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  padding: 10px 15px;
  box-shadow: var(--shadow-box);
  position: relative;
  cursor: pointer;

  /* Green underline when active */
  &::after {
    content: '';
    position: absolute;
    bottom: 0.5px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 2px;
    background: ${(props) => (props.$active ? 'var(--color-primary)' : 'transparent')};
    border-radius: 4px;
    transition: background 0.3s ease;
  }
`

export const StyledTabs = styled(Tabs)`
  align-self: stretch;
  height: 849px;

  /* Main nav container */
  .ant-tabs-nav {
    width: 300px;
    margin: 19px 0 20px 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    height: 40px;
    overflow: visible !important;
  }

  /* Remove default border */
  .ant-tabs-nav::before {
    border: none !important;
  }

  /* Container for the first 3 tabs (Info, Scans, Notes) */
  .ant-tabs-nav-wrap {
    flex: 0 0 auto;
    background: var(--color-bg);
    border-radius: 6px;
    padding: 10px 17px;
    box-shadow: var(--shadow-box);
    overflow: visible !important;
  }

  /* The list of tabs */
  .ant-tabs-nav-list {
    display: flex;
    overflow: visible !important;
  }

  /* Individual tab styling */
  .ant-tabs-tab {
    padding: 0;
    margin: 0;
    position: relative;
    overflow: visible !important;
  }

  /* Spacing between tabs (Info, Scans, Notes) */
  .ant-tabs-tab + .ant-tabs-tab {
    margin-left: 34px;
  }

  /* Tab button text */
  .ant-tabs-tab-btn {
    color: var(--color-text-primary);
    font-size: 16px;
    font-weight: bold;
    position: relative;
    display: inline-block;
  }

  /* Active tab text color */
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: var(--color-primary);
  }

  /* Hide default ink bar */
  .ant-tabs-ink-bar {
    display: none !important;
  }

  /* Custom underline for active tabs (except Traffic) */
  .ant-tabs-tab-active .ant-tabs-tab-btn::after {
    content: '';
    position: absolute;
    bottom: -7px;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--color-primary);
    border-radius: 4px;
    width: 100%;
    z-index: 10;
  }

  /* Content area */
  .ant-tabs-content-holder {
    padding-top: 0;
  }

  /* CRITICAL: Disable dropdown behavior */
  .ant-tabs-nav-operations {
    display: none !important;
  }

  /* Hide Traffic tab from main tab list */
  .ant-tabs-tab[data-node-key='traffic'] {
    display: none !important;
  }

  /* Style for tabBarExtraContent (Traffic button) */
  .ant-tabs-extra-content {
    display: flex !important;
    align-items: center;
    margin-left: auto;
  }
`

// Modal components
export const PopUp = styled(Modal)`
  width: 411px !important;
  background-color: var(--color-bg);
  border-radius: 4px;
`

export const PopUpMessage = styled.div`
  color: var(--color-text-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  width: 90%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PopUpButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding-bottom: 20px;
`
